module.exports = __webpack_public_path__ + "media/images/infinity-title-logo-wide-8a5d98439052036956aa377f34c934c1.png";